import React from "react";
import SearchNButtons from "../../common-components/SearchNButtons";

const DUFilters = ({
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  onClickAdd,
  search,
  setSearch
}) => {
  return (
    <>
      <SearchNButtons
        pageName={"diet-units"}
        btnText={"+ Add Unit"}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={onClickAdd}
        search={search}
        setSearch={setSearch}
      />
    </>
  );
};

export default DUFilters;
